import Icon from '@components/v2/ui/Icon/Icon';
import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { User } from 'lucide-react';
import { forwardRef, useState } from 'react';
import { useAvatarStyles } from './avatar.styles';

type Props = Pick<MuiAvatarProps, 'src' | 'alt' | 'sx' | 'className'> & {
  testId?: string;
  fallback?: 'initials' | 'icon';
  initials?: string;
  size?: number;
};

const Avatar = forwardRef<HTMLDivElement, Props>(
  ({ src, alt, sx, className, testId, fallback = 'initials', initials, size = 24 }, ref) => {
    const { classes, cx } = useAvatarStyles();
    const [isImgError, setIsImgError] = useState(false);

    return (
      <MuiAvatar
        src={src}
        alt={alt}
        sx={
          [
            {
              width: size,
              height: size,
              fontSize: size * 0.5,
              bgcolor: (theme) => (src && !isImgError ? 'transparent' : theme.palette.accent.main),
            },
            sx,
          ] as SxProps<Theme>
        }
        className={cx(classes.root, className)}
        variant={'rounded'}
        test-id={testId}
        ref={ref}
        onError={() => setIsImgError(true)}
      >
        {fallback === 'initials' && initials ? <span>{initials}</span> : <Icon icon={User} />}
      </MuiAvatar>
    );
  },
);

Avatar.displayName = 'Avatar';
export type { Props as AvatarProps };
export default Avatar;
